// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"231709fa","133":"6a4975fa","213":"06b65702","451":"23fed0cc","453":"6f1b4506","455":"28dbde88","806":"64fc4062"}[chunkId] + ".chunk.js";
};